<template>
  <section>
    <!-- 统计文字 -->
    <el-row class="total">
      <el-card class="box-card xs24" shadow="hover">
        <i class="el-icon-question sicon c1"></i>
        <span class="tjContent">
          <div>总访问人数</div>
          <div class="numText t1">{{((cdata.total.visit_uv||'0')+'').replace(/\d{1,3}(?=(\d{3})+$)/g, '$&,')}}</div>
        </span>
      </el-card>
      <el-card class="box-card xs24" shadow="hover">
        <i class="el-icon-success sicon c2"></i>
        <span class="tjContent">
          <div>总新增访问</div>
          <div class="numText t2">{{((cdata.total.visit_uv_new||'0')+'').replace(/\d{1,3}(?=(\d{3})+$)/g, '$&,')}}</div>
        </span>
      </el-card>
    </el-row>
    <el-row style="padding:15px;background:#fff">
      <el-col :sm="16" :xs="24" >
        <el-row :gutter="10">
          <el-button class="xs24" type="primary" plain @click="changeDate(1)">昨天</el-button>
          <el-button  class="xs24" type="primary" plain @click="changeDate(7)" id="seven">最近7天</el-button>
          <el-date-picker
          	class="xs24"
            v-model="dateVal"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="今天"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
          ></el-date-picker>
        </el-row>
      </el-col>
      <el-col :sm="8" :xs="24">
        <div style="float:right;text-align: right;">
          <el-row :gutter="10">
            <searchApp  class="xs24" @getid="changeId" compare="issued" :pholder="pholder"></searchApp>
          </el-row>
        </div>
      </el-col>
    </el-row>
    <!-- 图表 -->
    <el-row style="min-width:1200px;background:#fff" class="xs24">
      <div id="chart" style="width:100%; height:500px;"></div>
    </el-row>
    <!--列表-->
    <el-table :data="cdata.list" style="width: 100%;min-width:1200px" stripe row-key="id">
      <el-table-column prop="app_name" label="小游戏名称" align="left"></el-table-column>
      <el-table-column prop="visit_uv" label="访问人数" align="center"></el-table-column>
      <el-table-column prop="visit_uv_new" label="新增访问人数" align="center"></el-table-column>
      <el-table-column prop="share_uv" label="分享人数" align="center"></el-table-column>
      <el-table-column align="center">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="$router.push({
          name:'基础更多',
          params:{edate:pdata.edate,sdate:pdata.sdate,app_id:scope.row.app_id}
        })"
          >更多数据</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      class="pagination"
      @size-change="SizeChange"
      @current-change="CurrentChange"
      :current-page.sync="pdata.page"
      :page-sizes="[20, 40, 60, 80]"
      :page-size="pdata.perpage"
      background
      layout="sizes, prev, pager, next, jumper"
      :total="pdata.perpage*maxPage"
    ></el-pagination>

    <el-dialog title="编辑创意组合" :visible.sync="editDialog">
      <el-form :model="group"></el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialog = false">取 消</el-button>
        <el-button type="primary" @click="editDialog = false">确 定</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import { getBasicData, getAppid } from "../../api/api";
import echarts from "echarts";

export default {
  data() {
    return {
      chartColumn: null,
      pholder: "",
      pdata: {
        page: 1,
        perpage: 20,
        app_id: "",
        kw: "",
        sdate: new Date(new Date().getTime() - 3600 * 1000 * 7 * 24)
          .toISOString()
          .slice(0, 10),
        edate: new Date(new Date().getTime() - 3600 * 1000 * 24)
          .toISOString()
          .slice(0, 10)
        // sdate: "2019-04-15",
        // edate: "2019-04-15",
      },
      tText: "请选择创意类型",
      plist: [],
      maxPage: 1,
      config: [],
      editDialog: false,
      group: {},

      dateVal: [
        new Date(new Date().getTime() - 3600 * 1000 * 7 * 24)
          .toISOString()
          .slice(0, 10),
        new Date(new Date().getTime() - 3600 * 1000 * 24)
          .toISOString()
          .slice(0, 10)
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "昨天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, start]);
            }
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      cdata: { total: {}, chart: {}, list: [], max_page: 1 }, //所有数据
      option: {
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: ["访问人数", "新增访问人数"]
        },
        toolbox: {
          show: true,
          feature: {
            saveAsImage: { show: true }
          }
        },
        xAxis: {
          type: "category",
          
          data: []
        },
        yAxis: {
          type: "value"
        },
        series: [
          // "总访问人数", "总新增访问人数", "总收入","利润","买量成本","ROI"
          { name: "访问人数", type: "line", smooth: true, data: [] },
          { name: "新增访问人数", type: "line", smooth: true, data: [] }
        ],
        color: [
          "#61c0a0",
          "#ee4f54",
          "#8ec1b0",
          "#a6e8ba",
          "#ceead4",
          "#f2e247",
          "#f6e98b",
          "#f77b31",
          "#fc9656",
          "#ec151a",
          "#ee4f54",
          "#ee2159",
          "#fbaaa6"
        ]
      }
    };
  },
  watch: {
    dateVal: {
      handler(n, o) {
        if (n[0]) {
          this.pdata.sdate = n[0];
          this.pdata.edate = n[1];
          this.getList();
        }
      },
      deep: true
    }
  },
  methods: {
    getList() {
      var p = "";
      for (var k in this.pdata) {
        // if (this.pdata[k]) p += "&" + k + "=" + this.pdata[k];
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      getBasicData(p, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
          // "总访问人数", "总新增访问人数", "总收入","利润","买量成本","ROI"
          this.cdata = res.data;
          this.maxPage = res.data.max_page;
          this.option.xAxis.data = res.data.chart.date;
          this.option.series[0].data = res.data.chart.visit_uv;
          this.option.series[1].data = res.data.chart.visit_uv_new;
          this.drawColumnChart();
        }
      });
    },

    drawColumnChart() {
      this.chartColumn = echarts.init(document.getElementById("chart"));
      this.chartColumn.setOption(this.option);
    },
    SizeChange(v) {
      this.pdata.perpage = v;
      this.getList();
    },
    CurrentChange(v) {
      this.pdata.page = v;
      this.getList();
    },
    changeDate(s) {
      this.dateVal = [
        new Date(new Date().getTime() - 3600 * 1000 * 24 * s)
          .toISOString()
          .slice(0, 10),
        new Date(new Date().getTime() - 3600 * 1000 * 24)
          .toISOString()
          .slice(0, 10)
      ];
      // this.getList();
    },
    changeId(res) {
      this.pdata.app_id = res;
      this.getList();
    }
  },

  mounted() {
    document.getElementById("seven").focus();

    if (Object.keys(this.$route.params).length > 0) {
      this.pdata.sdate = this.$route.params.sdate;
      this.pdata.edate = this.$route.params.edate;
      this.pdata.app_id = this.$route.params.app_id;
      this.pholder = this.$route.params.name;
    }
    this.getList();
  }
};
</script>

<style lang="scss">
.el-button + .el-button {
  margin-left: 0;
}
#chart > div {
  margin: 0 auto;
}
</style>





// WEBPACK FOOTER //
// basicData.vue?b6892f46